<template>
  <TypeformTitle :title="`${store.applicationForm.opportunityTitle}`"
                 subtitle="Job Pending Verification – Check Back Later"
                 center>

    <div ref="container"/>

    <TypeformButtons
      class="mt-6 flex justify-center items-center"
      animate
      defaultText="Dismiss"
      @prevStep="$emit('cancel')"
      @nextStep="$emit('cancel')" />

    <div :class="animateClass"
         style="--anim-delay: 400ms;--to-opacity: 0.7;"
         class="flex items-center justify-center space-x-1 font-medium opacity-70 mt-4 mb-12">
      <ClockIcon class="h-4 w-4"/>
      <p>Verification takes up to 24 hours</p>
    </div>

  </TypeformTitle>
</template>

<script setup>
import TypeformButtons from "./TypeformButtons.vue";
import TypeformTitle from "./TypeformTitle.vue";
import {ClockIcon} from "@heroicons/vue/20/solid/index.js";
import {ref, provide} from "vue";
import {useAnimateInTrigger} from "../composables/AnimateInComposable";
import {useCandidateApplicationFormStore} from "../stores/CandidateApplicationFormStore";

const store = useCandidateApplicationFormStore();

defineEmits(["cancel"]);
defineProps({
  stepCount: Number,
  estimatedCompletionTime: String,
  isFirstStep: Boolean,
  isLastStep: Boolean,
});

const container = ref();
const animateClass = ref("animate-in-vars-pre");

provide("typeformIsLastStep", false);

useAnimateInTrigger(container, (className) => animateClass.value = className);
</script>
